import moment from "moment-timezone";
import { SlotsByDate } from "./types";

const SLOT_DURATION_MINUTES = 45;
const TIME_KEY_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export function getSortedDateKeys(group: SlotsByDate) {
  return Object.keys(group).sort();
}

export function getTimeKey(date: Date) {
  return moment(date).format(TIME_KEY_FORMAT);
}

export function getSlotEndTime(slot: Date) {
  return moment(slot).add(SLOT_DURATION_MINUTES, "minutes").toDate();
}

export function getSlotTimeLabel(slot: Date) {
  const endTime = getSlotEndTime(slot);
  return `${moment(slot).format("h:mm A")} – ${moment(endTime).format("h:mm A")}`;
}

export function isSlotSelected(
  slot: Date,
  selectedSlot: Date | null,
  isTimeConfirmed: boolean
) {
  return Boolean(
    isTimeConfirmed && selectedSlot && getTimeKey(selectedSlot) === getTimeKey(slot)
  );
}

export function flattenTimesByDate(timesByDate: SlotsByDate) {
  return getSortedDateKeys(timesByDate).flatMap((dateKey) => {
    const times = timesByDate[dateKey] ?? [];
    const dateLabel = moment(dateKey).format("ddd, MMM D");

    return times.map((time) => ({
      dateLabel,
      time,
      timeKey: getTimeKey(time),
    }));
  });
}
